import * as serializers from "serializers/legacy/legacy-objSerializer";
export { serializers };
export default serializers;
